import c from 'classnames';
import { TypeOptions } from 'react-toastify';
import { Icon } from '../Icon';
import styles from './ToastIcon.module.css';

type Props = {
  type: TypeOptions;
};

const icons: Record<TypeOptions, string> = {
  success: 'checkVerifiedFilled',
  error: 'alertCircleFilled',
  warning: 'alertTriangleFilled',
  info: 'infoCircleFilled',
  default: 'alertCircleFilled',
};

export default function ToastIcon({ type }: Props) {
  return <Icon name={icons[type]} className={c(styles.icon, styles[type])} />;
}
